import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { MediaAuthProvider } from "./contexts/MediaAuthContext";
import { PlayerProvider } from "./contexts/PlayerContext";
import MediaLayout from "./components/MediaLayout";
import MediaHome from "./pages/MediaHome";
import MediaWatch from "./pages/MediaWatch";
import MediaSearch from "./pages/MediaSearch";
import MediaCategory from "./pages/MediaCategory";
import MediaFavorites from "./pages/MediaFavorites";
import MediaHistory from "./pages/MediaHistory";
import MediaPlaylists from "./pages/MediaPlaylists";
import MediaAdmin from "./pages/MediaAdmin";
import MediaProfile from "./pages/MediaProfile";
import PageTracker from "@/components/PageTracker";

// Swallow benign media playback errors (browser autoplay block, Vimeo privacy)
// so the dev error overlay doesn't hijack the whole page.
function useSuppressMediaErrors() {
  useEffect(() => {
    const onRejection = (e) => {
      const msg = String(e?.reason?.message || e?.reason || "");
      if (/play\(\) failed|user didn't interact|NotAllowedError|privacy settings|Because of its privacy/i.test(msg)) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
      }
    };
    const onError = (e) => {
      const msg = String(e?.message || "");
      if (/play\(\) failed|user didn't interact|NotAllowedError|privacy settings|Because of its privacy/i.test(msg)) {
        e.preventDefault();
        e.stopImmediatePropagation?.();
      }
    };
    window.addEventListener("unhandledrejection", onRejection);
    window.addEventListener("error", onError);
    return () => {
      window.removeEventListener("unhandledrejection", onRejection);
      window.removeEventListener("error", onError);
    };
  }, []);
}

export default function MediaApp() {
  useSuppressMediaErrors();
  return (
    <MediaAuthProvider>
      <PlayerProvider>
        <PageTracker source="media" />
        <Routes>
          <Route path="login" element={<Navigate to="/login" replace />} />
          <Route element={<MediaLayout />}>
            <Route index element={<MediaHome />} />
            <Route path="watch/:id" element={<MediaWatch />} />
            <Route path="pesquisa" element={<MediaSearch />} />
            <Route path="categoria/:type" element={<MediaCategory />} />
            <Route path="favoritos" element={<MediaFavorites />} />
            <Route path="historico" element={<MediaHistory />} />
            <Route path="playlists" element={<MediaPlaylists />} />
            <Route path="perfil" element={<MediaProfile />} />
            <Route path="admin" element={<MediaAdmin />} />
          </Route>
        </Routes>
      </PlayerProvider>
    </MediaAuthProvider>
  );
}
